import * as React from "react";
import {resourcesHelper} from "@falcon/services";
import {TrustLogoComponent} from "@falcon/plugin-falcon-journey";

export default class FalconFooter extends React.Component {
    public render() {
        const divider = resourcesHelper.THEME === "Allianz" ? "" : " | ";

        return (
            <footer className="falcon-footer">
                <div className="falcon-footer-divider"></div>
                <div className="entrust-section">
                    <div id="trust-logo" className="security-logo position-relative">
                        <TrustLogoComponent/>
                    </div>
                    <div className={"entrust-section-wording"}>
                        <div className={"entrust-section-title"}>
                        We'll keep your details safe
                        </div>
                        <div className={"entrust-section-description"}>
                            Our website is constantly monitored to <br/>
                            check for harmful viruses or malware.
                        </div>
                    </div>
                    <div className={"d-flex justify-content-end flex-grow-1"}>
                        <img src={`/Allianz/img/allianz-olympic-logo.svg`}
                             alt={`Allianz olympics logo icon`}/>
                    </div>
                </div>
                <div className={"falcon-footer-divider-bottom"}></div>
                <hr aria-hidden="true"/>
                <div className={"trademark-section"}>
                    <div className={"links-container d-mobile-none"}>
                        <a href={"/complaints"} id="complaints" className={"pr-1"}>Complaints</a>{divider}
                        <a href={"https://www.allianz.co.uk/cookie-policy.html"} target="_blank" id="cookie-policy"
                           className={"pl-1 pr-1"}>Our cookie policy</a>{divider}
                        <a href={"https://www.allianz.co.uk/privacy-notice.html"} id="data-rights" target="_blank"
                           className={"pl-1"}>Personal data rights</a>
                    </div>
                    <div className={"links-container d-desktop-none"}>
                        <a href={"/complaints"} id="complaints">Complaints</a><br/><br/>
                        <a href={"https://www.allianz.co.uk/cookie-policy.html"} target="_blank" id="cookie-policy">Our
                            cookie policy</a><br/><br/>
                        <a href={"https://www.allianz.co.uk/privacy-notice.html"} id="data-rights" target="_blank">Personal
                            data rights</a><br/><br/>
                    </div>
                    <hr aria-hidden="true"/>
                    <div className={"trademark-container"}>
                        <div>
                            {resourcesHelper.TRADEMARK}
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation/FalconFooter.tsx